import React, { Fragment } from 'react';
import at from 'lodash.at';
import isObject from './is-object';
import getParsedPropValues from './get-parsed-prop-values';
import getSanitizedPropValues from './get-sanitized-prop-values';
import { BOLD_TAG, BLANK_SPACE_UNICODE_STRING } from '../constants';
import processDataSummaryValue from './process-data-summary-value';

// TODO this helper should be removed if database is wiped clean and all elements change to new props struc
const parsePropsToDisplay = (props = {}, propsToDisplay = []) => {
  if (!isObject(propsToDisplay[0])) return at(props, propsToDisplay).filter(Boolean);
  return propsToDisplay.map((options, currentIndex) => {
    const {
      bold,
      propertiesToDisplay,
      prefix,
      suffix,
      shouldStrip,
      enableLink
    } = options;
    const Wrapper = bold ? BOLD_TAG : Fragment;
    const parsedPropValues = getParsedPropValues({
      propertiesToDisplay,
      props,
      enableLink,
      shouldStrip
    });
    const sanitizedPropValues = getSanitizedPropValues(parsedPropValues);
    if (!sanitizedPropValues || !sanitizedPropValues.length) return null;
    const stringEndBlank = currentIndex + 1 === propsToDisplay.length ? '' : BLANK_SPACE_UNICODE_STRING;
    const processedValue = Array.isArray(sanitizedPropValues) ? sanitizedPropValues.map(value => processDataSummaryValue(value, options)) : processDataSummaryValue(sanitizedPropValues, options);
    return /*#__PURE__*/React.createElement(Wrapper, null, prefix, " ", processedValue, " ", suffix, stringEndBlank);
  });
};
export default parsePropsToDisplay;
//# sourceMappingURL=parse-props-to-display.js.map